import { Component } from 'react';

import styles from './feature-details.component.module.scss';

interface FeatureDetailsComponentProps {
    markdown: string;
}

export class FeatureDetailsComponent extends Component<FeatureDetailsComponentProps> {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.markdown) {
            // One card per <h4 ...> section; whatever precedes the first heading (a lead paragraph) is its own card,
            // unchanged. Lookahead split keeps each '<h4' with its section, so nothing is re-prefixed.
            const sections = this.props.markdown.split(/(?=<h4[\s>])/).map(s => s.trim()).filter(s => s.length > 0);
            if (sections.length > 0) {
                return <div className="row">
                    {
                        sections.map((html, index) => {
                            return <div key={`feature-detail-${index}`} className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                                <div className={`card section text-left ${styles['feature-details']}`}
                                    dangerouslySetInnerHTML={{ __html: html }}>
                                </div>
                            </div>
                        })
                    }
                </div>
            }
        }
        return <div className={`${this.props.markdown ? 'section' : ''} text-left ${styles['feature-details']}`}
            dangerouslySetInnerHTML={{ __html: this.props.markdown }}>
        </div>
    }
}